var React = require('react');

function IdentityVerification (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("defs",{"key":1},React.createElement("style",null,".cls-1{fill:#001b35}")),React.createElement("path",{"className":"cls-1","d":"M19.57 13.05a1.45 1.45 0 000-2.1l-2.25-2.12A7.71 7.71 0 0013.86 7v2.39a3.18 3.18 0 010 5.22v2.44a7.71 7.71 0 003.46-1.88z","key":2}),React.createElement("path",{"className":"cls-1","d":"M14 5.33V4h-4v1.33a1.33 1.33 0 011.32 1.33v.08a7.77 7.77 0 00-4.7 2.11L4.44 11a1.46 1.46 0 000 2.08l2.18 2.11a7.77 7.77 0 004.73 2.11v.08A1.33 1.33 0 0110 18.67V20h4v-1.33a1.33 1.33 0 01-1.32-1.33V6.66A1.33 1.33 0 0114 5.33zM8.76 12a3.21 3.21 0 012.59-3.15v6.3A3.21 3.21 0 018.76 12z","key":3})]);
}

IdentityVerification.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = IdentityVerification;

IdentityVerification.default = IdentityVerification;
